var React = require("react");
const PropTypes = require('prop-types');
const createReactClass = require("create-react-class");

var RadioButton = createReactClass({
	propTypes: {
		id: PropTypes.node.isRequired,
		type: PropTypes.string,
		value: PropTypes.bool,
		ssl: PropTypes.bool,
		dns: PropTypes.string,
		www: PropTypes.bool,
		onChange: PropTypes.func.isRequired
	},
	change: function() {
		this.props.onChange({
			action: "primary",
			id: this.props.id
		});
	},
	render: function() {
		var labelText = "";
		if(this.props.ssl) {
			labelText += "https://";
		}
		if(this.props.www) {
			labelText += "www.";
		}
		return (
			<label className="radio-inline">
				<input type="radio"
					checked={this.props.value}
					name={this.props.type}
					onChange={this.change}
					disabled={this.props.disabled}
					value={this.props.name}/>{labelText}{this.props.dns}
			</label>
		);
	}
});

module.exports = RadioButton;
